export default __webpack_public_path__ + "e1bcab4ceb17c3dd29bd4026de54112b.png";